import { apiRegistry } from '../../../common/infra/apiRegistry'
import { filesMem } from '../mem/filesMem'

apiRegistry.registerPostApi('moveFiles', async (request) => {
  const { fileIds, targetFolderId } = request
  const movedIds: string[] = []

  // Validate target folder exists (or is null for root)
  if (targetFolderId && !filesMem[targetFolderId]) {
    throw new Error('Target folder not found')
  }

  const targetPath = targetFolderId ? filesMem[targetFolderId].path : ''

  for (const fileId of fileIds) {
    const file = filesMem[fileId]
    if (!file) continue

    // Check for name conflicts in target folder
    const existingFiles = Object.values(filesMem).filter(f => f.parentId === targetFolderId)
    if (existingFiles.some(f => f.name === file.name && f.id !== fileId)) {
      throw new Error(`A file named "${file.name}" already exists in the target folder`)
    }

    // Update the file
    const oldPath = file.path
    const newPath = `${targetPath}/${file.name}`

    file.parentId = targetFolderId
    file.path = newPath
    file.modifiedDate = new Date().toISOString()

    // If it's a folder, update all children paths
    if (file.type === 'folder') {
      const children = Object.values(filesMem).filter(f => f.path.startsWith(oldPath + '/'))
      for (const child of children) {
        child.path = child.path.replace(oldPath, newPath)
      }
    }

    movedIds.push(fileId)
  }

  return { success: true, movedIds }
})